export enum TipoSolapaRancho {
    SolicitudRancho = 0,
    ListadoRanchoSolicitados = 1,
    ListadoRanchoConsumidos = 2
}